export default {
	setWiypCall: (storeObj: any, { familyComposition, origin, packageCode, packageId, response }: { familyComposition: string, origin: string, packageCode: string, packageId: string, response: any }) => {
		storeObj.commit("setWiypCall", { familyComposition, origin, packageCode, packageId, response });
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	},
	updateWiypCallWithAvailability: (storeObj: any, packagePrestMap: Map<string, Array<{ prestId: string, prestIdSource: string, prestIdFusion: string }>>) => {
		storeObj.commit("updateWiypCallWithAvailability", packagePrestMap);
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	},
	resetWiypCall: (storeObj: any) => {
		storeObj.commit("resetWiypCall");
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	},
	setWiypDefaultFlightOrigin: (storeObj: any, origin: string) => {
		storeObj.commit("setWiypDefaultFlightOrigin", origin);
	},
}

